import { Channel } from '../models/channel/channel.model';

export const channels: { data: Channel[] } = {
  data: [
    {
      code: 'TTS',
      name: 'TikTok Shop',
      description:
        'TikTok Shop is the newest and fastest growing e-commerce platform in the region. Offering a unique content-led e-commerce experience, it had an estimated GMV of __bn USD in the region in 2022.',
      id: '1',
      type: 'channels',
    },
    {
      name: 'Shopee',
      code: 'SHP',
      description:
        "Shopee is Southeast Asia's largest e-commerce platform, offering products across all popular categories including electronics, beauty, fashion, home & living, and health & wellness. It had an estimated GMV of about __bn USD in the region in 2022.",
      id: '2',
      type: 'channels',
    },
    {
      name: 'Lazada',
      code: 'LAZ',
      description:
        "Lazada is Southeast Asia's oldest multi-category e-commerce platform. With an estimated GMV of about __bn USD in the region in 2022, it is the second largest regional player after Shopee.",
      id: '3',
      type: 'channels',
    },
    {
      name: 'Mercado Libre',
      code: 'MEL',
      description:
        'Mercado Libre is the leading e-commerce and fintech ecosystem in Latin America, offering marketplace, payments, and logistics services across the region.',
      id: '4',
      type: 'channels',
    },
    {
      name: 'Redmart',
      code: 'RDM',
      description:
        'RedMart is an online grocery and household goods platform in Singapore.',
      id: '6',
      type: 'channels',
    },
    {
      name: 'Watsons',
      code: 'WAT',
      id: '7',
      type: 'channels',
    },
    {
      name: '711',
      code: '711',
      id: '8',
      type: 'channels',
    },
    {
      name: 'JD',
      code: 'JD',
      id: '9',
      type: 'channels',
    },
    {
      name: 'TMall',
      code: 'TM',
      id: '10',
      type: 'channels',
    },
    {
      name: 'Tmall-supermarket',
      code: 'TMS',
      id: '11',
      type: 'channels',
    },
    {
      name: 'MomoShop',
      code: 'MM',
      id: '12',
      type: 'channels',
    },
    {
      name: 'Amazon',
      code: 'AMZ',
      id: '13',
      type: 'channels',
    },
    {
      name: 'Tokopedia',
      code: 'TKP',
      id: '14',
      type: 'channels',
    },
    {
      name: 'GrabMart',
      code: 'GBM',
      id: '15',
      type: 'channels',
    },
    {
      name: 'Foodpanda',
      code: 'FPD',
      id: '16',
      type: 'channels',
    },
    {
      name: 'TikTok',
      id: '5',
      type: 'channels',
    },
  ],
};

export const channelAbbreviations: Record<string, string> = {
  'TikTok Shop': 'TTS',
  Shopee: 'SHP',
  Lazada: 'LAZ',
  'Mercado Libre': 'MEL',
  Redmart: 'RDM',
  Watsons: 'WAT',
  '711': '711',
  JD: 'JD',
  TMall: 'TM',
  'Tmall-supermarket': 'TMS',
  MomoShop: 'MM',
  Amazon: 'AMZ',
  Tokopedia: 'TKP',
  GrabMart: 'GBM',
  Foodpanda: 'FPD',
};
